import { render } from "./ReportOpenedOrders.vue?vue&type=template&id=30cd8c0a"
import script from "./ReportOpenedOrders.vue?vue&type=script&lang=js"
export * from "./ReportOpenedOrders.vue?vue&type=script&lang=js"

import "./ReportOpenedOrders.vue?vue&type=style&index=0&id=30cd8c0a&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__